import {
  createAuthorColumn,
  createLastReportedColumn,
  createPostColumn,
  createPublishedInColumnForContent
} from './Columns'
import { getReportedContent } from './service'
import { TrashTopic, Resolve } from './BulkActions'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'

const ReportedContentOverview = () => {
  const COLUMNS = [
    createPostColumn(),
    createPublishedInColumnForContent(),
    createAuthorColumn(),
    createLastReportedColumn()
  ]
  const BULK_ACTIONS = [Resolve, TrashTopic]

  return (
    <Overview
      type='report'
      headerTitle='Reported Content'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={COLUMNS}
      dataSource={getReportedContent}
      entity='posts'
      bulkActions={BULK_ACTIONS}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_spam.png`}
          header='All done!'
          text='There is no more reported content'
          button={{ link: '/overview', text: 'Go to content overview' }}
        />
      }
    />
  )
}

export default ReportedContentOverview
